import type { WPrezentationTranslations } from "./pl";

export const en: WPrezentationTranslations = {
  empty: "No slides to display.",
  prevSlide: "Previous slide",
  nextSlide: "Next slide",
  cta: "See more",
  openSlideAria: "Open",
  youtubeTitleFallback: "YouTube video",
};
